var render = function render(){
  var _vm$listPlanAvailabil;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-sidebar', {
    attrs: {
      "shadow": "lg",
      "right": "",
      "width": "65%",
      "bg-variant": "white",
      "title": "Create Maintenance & Docking Plan"
    },
    on: {
      "toggle": function toggle($event) {
        _vm.show.form = !_vm.show.form;
      }
    },
    model: {
      value: _vm.show.form,
      callback: function callback($$v) {
        _vm.$set(_vm.show, "form", $$v);
      },
      expression: "show.form"
    }
  }, [_vm.show.form ? [_c('FormMaintenanceDocking', {
    attrs: {
      "selectedData": _vm.selectedData,
      "optionsTaskType": _vm.optionsTaskType
    },
    on: {
      "close": function close($event) {
        _vm.show.form = false;
      },
      "refetch": function refetch() {
        _vm.show.form = false;
        _vm.fetchData();
      }
    }
  })] : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit",
      "loading": _vm.loadingImport
    },
    on: {
      "ok": _vm.handleimportTargetAv
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), !_vm.loadingExportTemplate ? _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTemplateAv
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")]) : _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    }
  }), _vm._v(" Downloading ")], 1)]], 2), _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "md",
      "title": "Filter Data",
      "ok-title": "Filter"
    },
    on: {
      "ok": _vm.fetchData
    },
    model: {
      value: _vm.showModalFilter,
      callback: function callback($$v) {
        _vm.showModalFilter = $$v;
      },
      expression: "showModalFilter"
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "b-label"
  }, [_vm._v("Date")])]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "range": "",
      "value-type": "YYYY-MM-DD",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "b-label"
  }, [_vm._v("Fleet Type")])]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('v-multiselect', {
    staticClass: "mr-2",
    attrs: {
      "placeholder": "Search Fleet Type",
      "label": "name",
      "options": _vm.optionsFleetTypes,
      "multiple": true,
      "required": "",
      "track-by": "id"
    },
    model: {
      value: _vm.params.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "vehicle_type_ids", $$v);
      },
      expression: "params.vehicle_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Fleet type not found.")])])], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "b-label"
  }, [_vm._v("Maintenance Type")])]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "options": [{
        label: 'Docking',
        id: 'docking'
      }].concat(_vm.optionsTaskType),
      "multiple": true,
      "label": "label",
      "track-by": "id"
    },
    model: {
      value: _vm.params.maintenance_or_task_types,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "maintenance_or_task_types", $$v);
      },
      expression: "params.maintenance_or_task_types"
    }
  })], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "ok-only": "",
      "top": "",
      "centered": "",
      "size": "md",
      "title": "Remark",
      "ok-title": "Close"
    },
    on: {
      "ok": function ok($event) {
        _vm.show.remark = false;
      }
    },
    model: {
      value: _vm.show.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.show, "remark", $$v);
      },
      expression: "show.remark"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "text-black",
    domProps: {
      "innerHTML": _vm._s(_vm.remark)
    }
  })])]), _c('div', {}, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center my-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "mr-2 text-nowrap",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showModalFilter = true;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders"
  }), _vm._v(" Filter Data ")]), _c('b-input', {
    staticClass: "mx-2",
    attrs: {
      "placeholder": "Search..."
    },
    on: {
      "keyup": _vm.onSearchKeyup
    },
    model: {
      value: _vm.params.search,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "search", $$v);
      },
      expression: "params.search"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "text-truncate mr-2",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "disabled": _vm.loadingExport,
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTargetAv
    }
  }, [_vm.loadingExport ? _c('b-spinner', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "16px",
      "height": "16px"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.loadingExport ? 'Loading...' : 'Export') + " ")], 1), _c('b-dropdown', {
    staticClass: "m-2",
    attrs: {
      "id": "dropdown-left",
      "text": "Create Data",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        _vm.show.form = true, _vm.selectedData = null;
      }
    }
  }, [_vm._v("New Data")]), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        _vm.showModal = true;
      }
    }
  }, [_vm._v("Import Data")])], 1)], 1)]), !_vm.loading ? [_c('div', {
    staticClass: "overflow-auto relative w-100"
  }, [_c('table', {
    staticClass: "w-100 striped-table"
  }, [_vm._m(0), _c('tbody', [(_vm$listPlanAvailabil = _vm.listPlanAvailabilities) !== null && _vm$listPlanAvailabil !== void 0 && _vm$listPlanAvailabil.length ? _vm._l(_vm.listPlanAvailabilities, function (item, index) {
    var _item$vehicle, _item$vehicle2, _item$vehicle2$vehicl, _item$task_type, _item$task_type2, _item$maintenance_typ;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "p-2"
    }, [_vm._v(_vm._s(_vm.getRowNumber(index)))]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$vehicle = item.vehicle) === null || _item$vehicle === void 0 ? void 0 : _item$vehicle.name))]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$vehicle2 = item.vehicle) === null || _item$vehicle2 === void 0 ? void 0 : (_item$vehicle2$vehicl = _item$vehicle2.vehicle_type) === null || _item$vehicle2$vehicl === void 0 ? void 0 : _item$vehicle2$vehicl.name))]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_c('div', {
      staticClass: "text-capitalize px-2 font-semibold",
      class: _vm.getColorType(item !== null && item !== void 0 && item.task_type ? item === null || item === void 0 ? void 0 : (_item$task_type = item.task_type) === null || _item$task_type === void 0 ? void 0 : _item$task_type.alias : item === null || item === void 0 ? void 0 : item.maintenance_type),
      staticStyle: {
        "border-radius": "4px",
        "width": "fit-content"
      }
    }, [_vm._v(" " + _vm._s(item !== null && item !== void 0 && item.task_type ? item === null || item === void 0 ? void 0 : (_item$task_type2 = item.task_type) === null || _item$task_type2 === void 0 ? void 0 : _item$task_type2.name : item === null || item === void 0 ? void 0 : (_item$maintenance_typ = item.maintenance_type) === null || _item$maintenance_typ === void 0 ? void 0 : _item$maintenance_typ.replace(/_/g, ' ')) + " ")])]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_vm._v(_vm._s(_vm.moment(item === null || item === void 0 ? void 0 : item.start_date).format('DD MMM YYYY')))]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_vm._v(_vm._s(item !== null && item !== void 0 && item.end_date ? _vm.moment(item === null || item === void 0 ? void 0 : item.end_date).format('DD MMM YYYY') : '-'))]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_vm._v(_vm._s(_vm.moment((item === null || item === void 0 ? void 0 : item.end_date) || new Date()).diff(item === null || item === void 0 ? void 0 : item.start_date, 'days') + 1) + " days")]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_c('b-button', {
      attrs: {
        "variant": "secondary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          _vm.show.remark = true, _vm.remark = item === null || item === void 0 ? void 0 : item.remark;
        }
      }
    }, [_vm._v(" Remark ")])], 1), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_vm._v(_vm._s(_vm.getPreferredStatus(item)))]), _c('td', {
      staticClass: "p-2 text-truncate"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center"
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          _vm.selectedData = item, _vm.show.form = true;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDelete(item);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])]);
  }) : [_vm._m(1)]], 2)])]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mb-0 mr-3",
    attrs: {
      "total-rows": _vm.meta.totalItems,
      "per-page": _vm.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": function change(page) {
        _vm.meta.page = page;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.page,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "page", $$v);
      },
      expression: "meta.page"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": function input() {
        _vm.meta.page = 1;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.perPage,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "perPage", $$v);
      },
      expression: "meta.perPage"
    }
  })], 1)] : _c('div', {
    staticClass: "d-flex justify-content-center p-5 w-100",
    attrs: {
      "colspan": "17"
    }
  }, [_c('b-spinner')], 1)], 2), _c('b-modal', {
    attrs: {
      "title": "Import Error Information",
      "ok-only": ""
    },
    model: {
      value: _vm.showErrImport,
      callback: function callback($$v) {
        _vm.showErrImport = $$v;
      },
      expression: "showErrImport"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "max-height": "70vh"
    }
  }, [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('th', {
    staticClass: "p-2",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Row Number")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Message")])]), _c('tbody', [_vm.msgErrImport.length ? _vm._l(_vm.msgErrImport, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "p-2 px-4"
    }, [_vm._v(_vm._s(item.rowNumber))]), _c('td', {
      staticClass: "p-2"
    }, [_vm._v(_vm._s(item.message))])]);
  }) : _vm._e()], 2)])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('th', {
    staticClass: "p-2"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Fleet Name")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Fleet Type")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Maintenance Type")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Start Date")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("End Date")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Duration")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Remarks")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "p-2 text-center"
  }, [_vm._v("Actions")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "col-1 sticky p-3",
    attrs: {
      "colspan": "17"
    }
  }, [_vm._v(" No data here! ")])]);

}]

export { render, staticRenderFns }